// RB-MY01-PalmGarden.web/src/pages/Unauthorized.tsx
import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="unauthorized-container">
      <h1>Access Denied</h1>
      <p>You don't have permission to access this page.</p>
      <p>Please contact an administrator if you believe this is an error.</p>
      
      <Button 
        variant="contained" 
        color="primary" 
        onClick={() => navigate('/dashboard')}
        sx={{ mt: 2 }}
      >
        Return to Dashboard
      </Button>
    </div>
  );
};

export default Unauthorized; 